module.exports = __webpack_public_path__ + "img/PC_03.6b9dcf95.jpg";